import {Component, Input, OnInit} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-text-field',
  templateUrl: './achoo-text-field.component.html',
  styleUrls: ['./achoo-text-field.component.scss']
})
export class AchooTextFieldComponent extends AchooInputComponent<any> {

  @Input()
  public isPageSearch: boolean;
  @Input()
  public isTelephoneField = false;
  @Input()
  public isPasswordField = false;
  @Input()
  public showError = true;

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-text-field/achoo-text-field.component.ts